export const isInViewPort = (element: HTMLElement) => {
  const { top, height } = element.getBoundingClientRect();
  const offset = Math.max(window.innerHeight - height, 0);

  return top <= offset && top >= -height;
};
